package navigation.home.request.allrequest

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.profile.domain.repository.ProfileRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.request.domain.repository.RequestRepository
import com.essntl.features.request.ui.allrequest.AllRequestEvent
import com.essntl.features.request.ui.allrequest.AllRequestState
import com.essntl.features.request.ui.allrequest.AllRequestViewModel
import com.essntl.toastmanager.ToastManager

class AllRequestScreenModel(
    requestRepository: RequestRepository,
    areaRepository: AreaRepository,
    proposalRepository: ProposalRepository,
    profileRepository: ProfileRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AllRequestState>(AllRequestState()) {
    private val allRequestViewModel =
        AllRequestViewModel(
            requestRepository = requestRepository,
            areaRepository = areaRepository,
            proposalRepository = proposalRepository,
            profileRepository = profileRepository,
            toastManager = toastManager,
            scope = screenModelScope,
            state = mutableState,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllRequestEvent) {
        allRequestViewModel.onEvent(event)
    }
}
